var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"load-options":_vm.loadOptions,"placeholder":"Try expanding any folder option..."},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }